import { DetailedHTMLProps, HTMLAttributes } from 'react';

import { FormFileFieldListRow } from './components';

import styles from './FormFileFieldListValue.module.scss';


type TProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	items: File[];
	onDelete: (value: File) => void;
};

export function FormFileFieldList(props: TProps) {
	const { onDelete, items = [] } = props;

	if (items.length <= 0) {
		return (
			<></>
		);
	}

	const classNames = [styles.list];

	return (
		<div className={ classNames.join(' ') }>
			{
				items.map(item => {
					const key = `${item.name}-${item.size}-${item.lastModified}`;

					return (
						<FormFileFieldListRow key={ key } file={ item } onDelete={ onDelete }>{ item.name }</FormFileFieldListRow>
					);
				})
			}
		</div>
	);
}
